import { uuidPattern } from "@/lib/raft_generic_helper";

const DurcAddEdit = () =>
  import("../../components/biologicals/Surveys/DurcAddEdit.vue");
const DurcGroupsListing = () =>
  import("../../components/biologicals/Surveys/DurcGroupsListing.vue");

const routes = [
  {
    path:
      "/node/:groupNid([0-9]+)/biologicals/surveys/durc/:uuid(" +
      uuidPattern +
      ")/edit",
    component: DurcAddEdit,
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/surveys/durc/create",
    component: DurcAddEdit,
    props: (route) => ({ groupNid: route.params.groupNid }),
  },
  {
    path: "/raft/biologicals/surveys/durc",
    component: DurcAddEdit,
    props: true,
  },
  {
    path: "/raft/biologicals/labs/durc",
    component: DurcGroupsListing,
    props: true,
  },
];

const globalComponents = {
  DurcAddEdit,
};

export {
  routes as bioSurveyRoutes,
  globalComponents as bioSurveyGlobalComponents,
};
